import apiCaller from 'src/util/apiCaller';

const newNguoiDung = function* newNguoiDung(item) {
  let data = apiCaller(`api/nguoidungs/create`, 'POST', item);
  return yield data ? data : [];
}

const deleteNguoiDung = function* deleteNguoiDung(id) {
  let data = apiCaller(`api/nguoidungs/${id}`, 'DELETE');
  return yield data ? data : [];
}

const deleteNguoiDungFromIS = function* deleteNguoiDungFromIS(email) {
  let data = apiCaller(`api/services/updateRoleListOfUser`, 'POST', email);
  return yield data ? data : [];
}

const newUserServerIS = function* newUserServerIS(item) {
  let data = apiCaller(`api/services/addUser`, 'POST', item);
  return yield data ? data : [];
}

export const NguoiDungsAPI = {
  newNguoiDung,
  deleteNguoiDung,
  deleteNguoiDungFromIS,
  newUserServerIS
};